import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { BTN_DARK_THEME, NO_ICON, SIZE_48, TEXT_VARIANT } from '@yme/atoms/button';
import { Megamenu } from '../Megamenu';
import { HEADER_PORTAL_ID } from '../constants';
import { setIsMenuActive } from '../redux/actions';
import { OverlayStyled } from '../styled';
import { NestedMenuContainer } from './NestedMenuContainer';
import { MenuItemStyled, MenuLinkStyled } from './styled';
const getHasNestedList = (children) => Boolean(children.length);
export function MenuItem({ item, headerLabels, element, isRightToLeft }) {
    const { title, childPages } = item;
    const dispatch = useDispatch();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const portalContainer = document.getElementById(HEADER_PORTAL_ID);
    const menuItemClickCount = useRef(0);
    const closeMenuHandler = useCallback(() => {
        dispatch(setIsMenuActive(false));
        setIsMenuOpen(false);
    }, [dispatch]);
    const toggleMenuHandler = useCallback((e, hasNestedList, menuItemClickCount) => {
        if (!hasNestedList) {
            return;
        }
        e.preventDefault();
        if (menuItemClickCount % 2 == 0) {
            closeMenuHandler();
        }
        else {
            dispatch(setIsMenuActive(!isMenuOpen));
            setIsMenuOpen(!isMenuOpen);
        }
    }, [closeMenuHandler, dispatch, isMenuOpen]);
    const hasNestedList = getHasNestedList(childPages);
    useEffect(() => {
        if (!isMenuOpen) {
            menuItemClickCount.current = 0;
        }
    }, [isMenuOpen]);
    useEffect(() => () => {
        dispatch(setIsMenuActive(false));
        setIsMenuOpen(false);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const onClickMenuLinkHandler = useCallback((e) => {
        menuItemClickCount.current += 1;
        item.onClick();
        toggleMenuHandler(e, hasNestedList, menuItemClickCount.current);
    }, [item, toggleMenuHandler, hasNestedList]);
    return (React.createElement(MenuItemStyled, { isRightToLeft: isRightToLeft, isActive: isMenuOpen, ref: element },
        React.createElement(MenuLinkStyled, { draggable: false, buttonVariant: TEXT_VARIANT, colorSchema: BTN_DARK_THEME, hasIconButton: NO_ICON, label: title, size: SIZE_48, onClick: onClickMenuLinkHandler }, title),
        isMenuOpen &&
            portalContainer &&
            createPortal(React.createElement(React.Fragment, null,
                React.createElement(NestedMenuContainer, { onCloseMenu: closeMenuHandler, isRightToLeft: isRightToLeft },
                    React.createElement(Megamenu, { navItems: item, headerLabels: headerLabels, closeMenuHandler: closeMenuHandler })),
                React.createElement(OverlayStyled, null)), portalContainer)));
}
